<template>
  <!-- NOTE (TEMPLATE) to show all proposals -->

  <div class="animated fadeIn">
    <newUniRequestForm />
  </div>
</template>

<script>
import newUniRequestForm from "../../components/newUniRequestForm";
export default {
  components: { newUniRequestForm },
};
</script>
